import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoanApiService } from '../../services/loan-api.service';

@Injectable({ providedIn: 'root' })
export class PipelineDataResolver implements Resolve<boolean> {
  public _parsedStagesSub$ = new BehaviorSubject(null);
  private _parsedStages: any;
  private _stages: any[];
  private _pipelines: any[];

  private _parsedStagesById: any;

  constructor(private loanApiService: LoanApiService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.getPipelines();
  }

  public getPipelines() {
    if (this._parsedStagesSub$.getValue()) {
      return of(this._parsedStagesSub$.getValue());
    } else {
      return this.loanApiService.getPipelines().pipe(
        map((pipelines: any) => {
          return this.parseAllStages(pipelines);
        })
      );
    }
  }

  private parseAllStages(pipelines) {
    this._parsedStages = {};
    this._parsedStagesById = {};
    this._pipelines = pipelines;
    const stages = pipelines.reduce((stages, item) => stages.concat(...item.Stages), []);
    stages.forEach((stage) => {
      this._parsedStages[stage.name] = stage;
      this._parsedStagesById[stage.id] = stage;
    });

    this._stages = stages;
    this._parsedStagesSub$.next(this._parsedStages);
    return this._parsedStages;
  }

  public getStageByName(name) {
    return this.parsedStages[name];
  }

  public getStageIdByName(name) {
    return this.parsedStages[name].id;
  }

  public getStageById(id) {
    return this._parsedStagesById[id];
  }

  get parsedStages() {
    return this._parsedStages;
  }

  get stages() {
    return this._stages;
  }

  get pipelines() {
    return this._pipelines;
  }

  get parsedStagesSub$() {
    return this._parsedStagesSub$.asObservable();
  }

  get allStagesWithIds() {
    /*
    return object of stages name as key and id as value of these stages ['APPLICATION_INTAKE', 'QUALIFICATION', 'LOAN_SETUP','LOAN_FUNDED', 'DOCS_SIGNED', 'QC_COMPLETE' ,'SUSPENDED', 'ADVERSE']
 sample data {APPLICATION_INTAKE:1, QUALIFICATION:2}
 */
    return Object.keys(this.parsedStages).reduce((acc, curr) => {
      acc[curr] = this.parsedStages[curr].id;
      return acc;
    }, {});
  }

  get closedLoanStages() {
    const closedLoanStages = ['LOAN_FUNDED', 'BROKER_CHECK_RECEIVED', 'COMMISSION_PAID', 'SUSPENDED', 'ADVERSE'];
    return this.parsedStages ? closedLoanStages.map((name) => this.parsedStages[name]?.id) : [];
  }
}
